import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBaseComponentsConfig() {
    return {
        palette: {
            [PALETTE_IDS.DOT_NOTIFICATION]: {
                DOT_COLOR: COLOR.BRAND.ACCENT3,
            },
            [PALETTE_IDS.STREAMING_INDICATOR]: {
                INDICATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.NEUTRAL_VENUE_INDICATOR]: {
                NVI_POPOVER_BG: COLOR.BRAND.BACKGROUND5,
            },
            [PALETTE_IDS.ODDS_BUTTON]: {
                ODDS_DISABLED_BG: COLOR.BASE.DIVIDER,

                ODDS_SELECTED_INFO_TEXT: {
                    fontSize: FONT.SIZE_MEDIUM,
                },
                ODDS_UNAVAILABLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
            [PALETTE_IDS.PRICE_CHANGE_INDICATOR]: {
                PRICE_CHANGE_INDICATOR_DOWN_COLOR: COLOR.SEMANTIC.ERROR1,
                PRICE_CHANGE_INDICATOR_UP_COLOR: COLOR.SEMANTIC.SUCCESS1,
            },
            [PALETTE_IDS.POPOVER]: {
                POPOVER_BG: COLOR.BASE.PAGE,
                POPOVER_TEXT: COLOR.BRAND.FOREGROUND1,
                POPOVER_CLOSE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.PRIMARY_LINK]: {
                PRIMARY_LINK_TEXT: COLOR.BRAND.FOREGROUND1,
                PRIMARY_LINK_BG: COLOR.BRAND.BACKGROUND1,
                PRIMARY_LINK_BORDER_COLOR: COLOR.BRAND.FOREGROUND7,
            },
            [PALETTE_IDS.DROPDOWN_MENU]: {
                DROPDOWN_MENU_ITEM_TEXT: COLOR.BRAND.FOREGROUND1,
                DROPDOWN_MENU_ITEM_BG: COLOR.BRAND.BACKGROUND1,
                DROPDOWN_MENU_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT1,
            },
            [PALETTE_IDS.PRIMARY_DROPDOWN]: {
                PRIMARY_DROPDOWN_BG: COLOR.BRAND.BACKGROUND5,
                PRIMARY_DROPDOWN_ICON_COLOR: COLOR.BRAND.ACCENT3,
                PRIMARY_DROPDOWN_DISABLED_BG: COLOR.BRAND.FOREGROUND4,
                PRIMARY_DROPDOWN_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
            },
            [PALETTE_IDS.SECONDARY_DROPDOWN]: {
                SECONDARY_DROPDOWN_ICON_COLOR: COLOR.BRAND.ACCENT3,
                SECONDARY_DROPDOWN_BORDER_COLOR: COLOR.BRAND.FOREGROUND3,
            },
            [PALETTE_IDS.TERTIARY_DROPDOWN]: {
                TERTIARY_DROPDOWN_ICON_COLOR: COLOR.BRAND.ACCENT3,
                TERTIARY_DROPDOWN_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
            },
            [PALETTE_IDS.BET_FUNDS_INFO]: {
                BET_FUNDS_INFO_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
                BET_FUNDS_INFO_MEDIUM_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
                BET_FUNDS_INFO_EMPHASIZED_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
            },
            [PALETTE_IDS.TOGGLE_BUTTON]: {
                TOGGLE_BUTTON_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND4}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                TOGGLE_BUTTON_SELECTED_BG: COLOR.BRAND.ACCENT2,
                TOGGLE_BUTTON_BG: COLOR.BRAND.BACKGROUND1,
                TOGGLE_BUTTON_SELECTED_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                TOGGLE_BUTTON_DISABLED_TEXT: `${COLOR.BRAND.FOREGROUND7}|${COLOR.BRAND.FOREGROUND3}`,
                TOGGLE_BUTTON_BORDER_RADIUS: 20,
            },
            [PALETTE_IDS.PRIMARY_BUTTON]: {
                PRIMARY_BUTTON_BG: COLOR.BRAND.CTA1,
                PRIMARY_BUTTON_TEXT: COLOR.BRAND.FOREGROUND1,
                PRIMARY_BUTTON_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
                PRIMARY_BUTTON_DISABLED_BG: COLOR.BRAND.FOREGROUND4,
            },
            [PALETTE_IDS.SECONDARY_BUTTON]: {
                SECONDARY_BUTTON_BORDER_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.CTA1}`,
                SECONDARY_BUTTON_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.CTA1}`,
                SECONDARY_BUTTON_SELECTED_BG: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.CTA1}`,
                SECONDARY_BUTTON_SELECTED_TEXT: `${COLOR.BRAND.FOREGROUND6}|${COLOR.BRAND.FOREGROUND1}`,
                SECONDARY_BUTTON_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
                SECONDARY_BUTTON_DISABLED_BORDER_COLOR: COLOR.BRAND.FOREGROUND3,
            },
            [PALETTE_IDS.TERTIARY_BUTTON]: {
                TERTIARY_BUTTON_SELECTED_BG: `${COLOR.BRAND.BACKGROUND4}|${COLOR.BRAND.BACKGROUND1}`,
                TERTIARY_BUTTON_SELECTED_TEXT: `${COLOR.BRAND.BACKGROUND1}|${COLOR.BRAND.FOREGROUND1}`,
                TERTIARY_BUTTON_DISABLED_TEXT: COLOR.BRAND.FOREGROUND3,
                TERTIARY_BUTTON_ICON_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.ACCENT1}`,
            },
            [PALETTE_IDS.CHECKBOX]: {
                CHECKBOX_BG: COLOR.BRAND.FOREGROUND6,
                ON_DARK: {
                    CHECKBOX_BG: COLOR.RESERVED.TRANSPARENT,
                },
                CHECKBOX_BORDER_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
                CHECKBOX_LABEL: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
                    fontSize: FONT.SIZE_MEDIUM,
                },
            },
            [PALETTE_IDS.PIVOT]: {
                PIVOT_INDICATOR_BG: COLOR.BRAND.ACCENT1,
                PIVOT_ICON_COLOR: COLOR.BRAND.BACKGROUND6,
                PIVOT_SELECTED_ICON_COLOR: COLOR.BRAND.BACKGROUND6,
                ON_DARK: {
                    PIVOT_ICON_COLOR: COLOR.BRAND.ACCENT1,
                    PIVOT_SELECTED_ICON_COLOR: COLOR.BRAND.ACCENT1,
                },
            },
            [PALETTE_IDS.SCROLL_BUTTON]: {
                SCROLL_BUTTON_BG: COLOR.BASE.SCRIM_DARK,
                SCROLL_BUTTON_ICON_COLOR: COLOR.BRAND.ACCENT1,
            },
            [PALETTE_IDS.CLOSE_BUTTON]: {
                CLOSE_BUTTON_ICON_COLOR: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND6}`,
                CIRCULAR_CLOSE_BUTTON_BG: COLOR.BRAND.FOREGROUND7,
            },
            [PALETTE_IDS.EVENT_TIMING_STATUS]: {
                EVENT_TIMING_LIVE_TEXT: {
                    color: COLOR.BRAND.CTA2,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                EVENT_TIMING_UPCOMING_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND6}`,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
            },
            [PALETTE_IDS.MINI_SCOREBOARD]: {
                MINI_SCOREBOARD_SCORES_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.BACKGROUND7,
                },
                MINI_SCOREBOARD_SCORE_COUNT_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    color: COLOR.BRAND.CTA2,
                },
                MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT: COLOR.BRAND.FOREGROUND2,
                MINI_SCOREBOARD_SERVER_INDICATOR: COLOR.BRAND.ACCENT3,
            },
            [PALETTE_IDS.RUNNER_INFO]: {
                COMPACT_TRICAST_RUNNER_TEXT: {
                    fontWeight: FONT.WEIGHT_BOLD,
                    color: COLOR.BRAND.FOREGROUND1,
                },
                RUNNER_CONTAINER_TEXT: COLOR.BRAND.FOREGROUND2,
                RUNNER_DRAW_NUMBER_TEXT: COLOR.BRAND.FOREGROUND2,
                RUNNER_TRAINER_AND_JOCKEY_NAMES_TEXT: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.TABLE]: {
                TABLE_HEADER_BG: COLOR.BRAND.BACKGROUND4,
                TABLE_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND4,
                    fontWeight: FONT.WEIGHT_NORMAL,
                },
                TABLE_ITEM_BG: COLOR.BRAND.BACKGROUND1,
                TABLE_ITEM_SELECTED_BG: COLOR.BRAND.FOREGROUND5,
                TABLE_ITEM_TEXT: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.PARTICIPANTS]: {
                PARTICIPANTS_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                PITCHER_TEXT: COLOR.BRAND.FOREGROUND2,
            },

            [PALETTE_IDS.BET_BASE_INFO]: {
                BET_TITLE_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND4}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                BET_DATE_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,
                BET_STATUS_TEXT: {
                    textTransform: 'capitalize',
                    color: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,
                },
                BET_SELECTION_NAME_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND3}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                BET_TYPE_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND3}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                BET_MARKET_NAME_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND3}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                BET_BUILDER_BET_MARKET_NAME_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,
                BET_TOTAL_ODDS_LABEL_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,
            },
            [PALETTE_IDS.ODDS_BOOST_BANNER]: {
                ODDS_BOOSTS_COMMON_COLOR: COLOR.BRAND.FOREGROUND3,
                ODDS_BOOSTS_RETURNS_TEXT: {
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
            },
            [PALETTE_IDS.BET_BUILDER_SELECTION_ITEM]: {
                BB_BET_SELECTION_NAME_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.FOREGROUND4}`,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                },
                BB_BET_MARKET_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND7}`,
            },
            [PALETTE_IDS.BET_STATUS_ICON]: {
                OPEN_BET_ICON_COLOR: COLOR.RESERVED.ACCENT,
            },
            [PALETTE_IDS.PROGRESS_BAR]: {
                PROGRESS_BAR_LINE_COLOR: COLOR.BRAND.BACKGROUND5,
                PROGRESS_BAR_FILL_LINE_COLOR: COLOR.BRAND.ACCENT1,
                PROGRESS_BAR_LIMIT_LABEL_TEXT: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.PRICE_BOOST_LABEL]: {
                PRICE_BOOST_LABEL_ICON_SIZE: 20,
                PRICE_BOOST_LABEL_TEXT: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
            },
            [PALETTE_IDS.BONUS_INDICATOR]: {
                BONUS_INDICATOR_TEXT: `${COLOR.BRAND.FOREGROUND2}|${COLOR.BRAND.FOREGROUND4}`,
                BONUS_INDICATOR_ICON_COLOR: COLOR.BRAND.ACCENT3,
                BONUS_INDICATOR_AWARDED_BG: COLOR.BRAND.ACCENT3,
            },
            [PALETTE_IDS.FAVORITE_ICON]: {
                FAVORITE_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
            },
            [PALETTE_IDS.SCOREBOARD]: {
                SCOREBOARD_SCORE_BG: COLOR.BRAND.CTA1,
                SCOREBOARD_ACTIVE_SCORE_BG: COLOR.BRAND.CTA2,
                SCOREBOARD_ACTIVE_SCORE_TEXT: COLOR.BRAND.FOREGROUND6,
            },
        },
    };
}
